import { useState } from "react";

import { Dialog } from "primereact/dialog";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Badge } from "primereact/badge";
import { arrayMoveMutable } from 'array-move';
import { ReactSortable } from "react-sortablejs";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import ScreenLoader, { ScreenLoader2 } from "../../componets/ScreenLoader";




function markAlternatingGender(data) {
    // var data = JSON.parse(JSON.stringify(data))
    return data.map((item, index, arr) => {
        if (index === 0) return { ...item, valid: true };

        const prevGender = arr[index - 1].gender?.toLowerCase();
        const currGender = item.gender?.toLowerCase();
        const isValid = prevGender !== currGender;

        return { ...item, valid: isValid };
    });
}
export default function ({ list, setShow, show, onRefresh }) {
    var [sortList, setSortList] = useState(list)
    var [loading, setLoading] = useState(false)
    var political = new PoliticalPartyService();

    return (<>
        <Dialog
            header={
                <>
                    <h5 className="my-0">
                        Sorting  Members
                    </h5>
                </>
            }
            style={{ width: "100%", maxWidth: "1000px", height: "100%" }}
            visible={show?.sorting} onHide={() => {
                setShow({ ...show, sorting: false })
                onRefresh()
            }

            }>
            <ScreenLoader2 visible={loading} />
            <ReactSortable
                onEnd={() => {
                    // fix the order to save
                    // var res = markAlternatingGender(sortList).find(e => e.valid === false);
                    // if (res) {
                    //     return;
                    // }
                    setLoading(true)
                    political.updateAllPolitical_proportional_candidatesOrder(sortList).then(res => {
                        setTimeout(() => {
                            // onRefresh()
                            setLoading(false)
                        }, 500);


                    })
                }}
                list={markAlternatingGender(sortList)}
                setList={(newState) => {
                    newState = newState.map((e, index) => {
                        e.candidateOrder = index + 1
                        return e;
                    })
                    setSortList(newState)
                }}
            >
                {markAlternatingGender(sortList).map((value, index) => (
                    <div className="card my-2" style={{ position: "relative" }} >
                        <span className="mr-2">{index + 1}</span> <Badge severity={value.gender === "Male" ? "success" : "info"} value={value.gender} /> {value.name}-{value.surname}
                        {value.valid === false && <div className="flex" style={{ borderBottom: "1px solid red", color: "red", width: "100%", position: "absolute", bottom: 0, left: 0, right: 0 }}>
                            {/* <b><small>Invalid order</small></b> */}
                        </div>}
                    </div>
                ))}
            </ReactSortable>

        </Dialog>
    </>)
}